<template>
    <div class="container">
        <div class="content borderBox h100 marginAuto flex justifyContentSpaceBetween">
            <div class="flex alignItemsCenter">
                <div class="logo">
                    <img style="width: 145px;" src="/images/header/logoTZDL.png" alt="logo">
                </div>
                <div class="h100 navBar">
                    <div class="h100 flex alignItemsCenter">
                        <div @click.stop="navToGame(item)" v-for="(item,index) in navBar" :key="index"
                             :class="{currentNav:item.hasOwnProperty('name') && ($route.params.type === item.name || $route.fullPath === item.url)}"
                             class="navItme relative h100 font16 pointer">
                            {{l(item.title)}}
                            <template v-if="item.title === 'gdyx'">
                                <div class="absolute w100"
                                     style="height: 4px;bottom: 0;transform: translate(0,100%)"></div>
                                <div class="moreNavBar slidedown absolute">
                                    <p @click.stop="navToGame(item1)" v-for="(item1,i) in moreNavBar" :key="i"
                                       :class="{currentNav:item1.name && $route.params.type === item1.name}"
                                       class="pointer flex alignItemsCenter justifyContentCenter">
                                        <img :src="`/images/header/more_${item1.icon}.png`" alt="">
                                        <span>{{l(item1.title)}}</span>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justifyContentCenter">
                <div class="h100 tools flex alignItemsCenter">
                    <div @click="toolsFn(item)"
                         v-for="(item,index) in tools"
                         :key="index"
                         class="relative pointer flex column alignItemsCenter justifyContentCenter">
                        <img :src="`/images/header/h_${item.icon}.png`" :alt="item.title" class="iconImg">
                        <span class="font12">{{l(item.title)}}</span>
                        <template v-if="item.title === 'App' && isLogin()">
                            <div class="appDownLoad slidedown textAlignCenter borderBox absolute">
                                <p class="font14">{{l('sjsmxz')}}</p>
                                <img :src="appDownLoadImg" class="absolute" alt="">
                                <p class="font12 absolute w100" style="bottom: 15px">
                                    <span>{{l('sjksfw')}}</span>
                                    <!--                                    <span>v8.cc</span>-->
                                </p>
                            </div>
                        </template>
                    </div>
                    <div v-if="isLogin(false)"
                         @click="$router.push({path: '/userCenter/financialDetails'}).catch(err=>'')"
                         class="relative pointer flex column alignItemsCenter justifyContentCenter">
                        <img src="/images/header/h_mingxi.png" class="iconImg">
                        <span class="font12">{{l('zjmx')}}</span>
                    </div>
                </div>
                <template v-if="!isLogin(false)">
                    <div class="notLogin font16 textAlignCenter flex alignItemsCenter">
                        <p @click="setStoreState({prop:'showLogin',value:'login'})"
                           class="login pointer hover colorfff">{{l('dl')}}</p>
                        <p @click="setStoreState({prop:'showLogin',value:'register'})" class="register pointer hover">
                            {{l('zc')}}</p>
                    </div>
                </template>
                <template v-else>
                    <alreadyLogin></alreadyLogin>
                </template>
            </div>
        </div>
        <logOn></logOn>
        <deposit></deposit>
        <withdrawMoney></withdrawMoney>
        <collectionSettings></collectionSettings>
        <addAccount></addAccount>
    </div>
</template>

<script>
    import {qrcanvas} from "qrcanvas"

    import {mapState} from "vuex"

    import {getHomeListApi} from "@/api"

    export default {
        name: "index",
        components: {
            alreadyLogin: () => import('./components/alreadyLogin'),
            logOn: () => import('../logOn'),
            deposit: () => import('../deposit'),
            withdrawMoney: () => import('../withdrawMoney'),
            collectionSettings: () => import('../collectionSettings'),
            addAccount: () => import('../addAccount'),
        },
        computed: {...mapState(['platformInfo', 'userInfo', 'navBarInfo'])},
        data() {
            const navBar = [
                {url: '/', title: 'sy1', name: ''},
                {title: 'tzsx', name: 'live'},
                {title: 'zr', name: 'thirdlive'},
                {title: 'cp', icon: 'cp', name: 'lottery'},
                {title: 'gdyx'}
            ]
            const moreNavBar = [
                {title: 'dz', icon: 'dz', name: 'egame'},
                {title: 'qp', icon: 'qp', name: 'boardcard'},
                {title: 'by', icon: 'dj', name: 'fish'},
                {title: 'ty', icon: 'cp', name: 'sport'}
            ]
            const tools = [
                // {title: '赞助', icon: 'zanzhu'},
                {title: 'App', icon: 'app'},
                {title: 'kf', icon: 'kefu'},
                // {title: '资金明细', icon: 'mingxi'},
            ]
            return {
                navBar,
                moreNavBar,
                tools,
                selfNavBarInfo: [], //导航信息
                appDownLoadImg: '',  //二维码
            }
        },
        watch: {
            'platformInfo': {
                handler(newVal, oldVal) {
                    if (newVal?.appDownloadUrl) {
                        this.appDownLoadImg = qrcanvas({
                            data: newVal?.appDownloadUrl,
                        }).toDataURL('image/png')
                    }
                }, immediate: true
            },
            'navBarInfo': {
                handler(newVal, oldVal) {
                    this.selfNavBarInfo = JSON.parse(JSON.stringify(newVal))
                }, immediate: true
            },
        },
        created() {
            this.useInterceptedOnMounted(this.init)
        },
        methods: {
            init() {
                //登录状态下才发起
                if (this.isLogin(false)) {
                    getHomeListApi({currency: this.userInfo.currency}).then(res => {
                        if (!res.data) return
                        // this.selfNavBarInfo = res.data.result

                        //缓存到vuex里面

                        this.setStoreState({prop: 'navBarInfo', value: res.data.result})
                    })
                }
            },
            toolsFn(item) {
                if (item.title === 'App') {
                    this.isLogin(true)
                    return
                }

                if (item.title === 'kf') {
                    this.toOnlineService()
                    return
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        height: 80px;
        background-image: linear-gradient(0deg,
                #fffdfb 0%,
                #f9f5f1 54%,
                #fffdfa 76%,
                #f8f3ed 92%),
        linear-gradient(
                        #f5f8ff,
                        #f5f8ff);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 2px 3px 0px rgba(0, 93, 141, 0.13);

        .content {
            padding: 0 20px;
            width: 1200px;

            .navBar {
                line-height: 80px;
                margin-left: 40px;
                color: #39270c;

                .navItme {
                    line-height: 80px;

                    &.current {
                        color: #e5bf5c;
                    }

                    &:not(:last-child) {
                        margin-right: 30px;
                    }

                    &:hover {
                        color: #e5bf5c;

                        &:last-child::after {
                            transform: translate(calc(100% + 5px), -50%) rotateZ(180deg);
                        }

                        .moreNavBar {
                            display: block;
                        }
                    }

                    &.currentNav {
                        color: #e5bf5c;
                    }

                    &:last-child::after {
                        display: block;
                        content: '';
                        position: absolute;
                        width: 14px;
                        height: 14px;
                        top: 50%;
                        right: 0;
                        transition: .3s;
                        transform-origin: center center;
                        transform: translate(calc(100% + 5px), -50%) rotateZ(0deg);
                        background: url("@images/header/h_jt_s.png") no-repeat center center/contain;
                    }
                }

                .moreNavBar {
                    display: none;
                    right: 0;
                    left: 50%;
                    overflow: hidden;
                    transform: translate(-50%, 4px);
                    width: 125px;
                    color: #4c3e2a;
                    background-color: #ffffff;
                    box-shadow: 0px 3px 7px 0px rgba(144, 102, 47, 0.31);
                    border-radius: 10px;

                    p {
                        line-height: 52px;

                        &:hover {
                            background-color: #f2f0ed;
                        }

                        &.currentNav {
                            background-color: #f2f0ed;
                        }

                        img {
                            width: 27px;
                            height: 27px;
                            margin-right: 20px;
                        }
                    }
                }
            }

            .tools {
                color: #39270c;

                > div {
                    padding: 0px 18px;

                    &:hover {
                        > span, > img {
                            transition: .3s;
                            opacity: .7;
                        }

                        .appDownLoad {
                            display: block;
                        }
                    }
                }

                .iconImg {
                    width: 25px;
                    height: 25px;
                    margin-bottom: 10px;
                }

                .appDownLoad {
                    display: none;
                    color: #6c4f62;
                    width: 155px;
                    height: 230px;
                    padding-top: 35px;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 100%);
                    background: url("@images/header/app_xz.png") no-repeat center center/contain;

                    > img {
                        width: 115px;
                        height: 115px;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, calc(-50% + 10px));
                    }
                }
            }

            .notLogin {
                p {
                    width: 86px;
                    height: 37px;
                    line-height: 30px;
                }

                .login {
                    margin-left: 13px;
                    background: url("@images/header/login_btn.png") no-repeat center center/cover;
                }

                .register {
                    color: #39270c;
                    margin-left: 20px;
                    background: url("@images/header/reg_btn.png") no-repeat center center/cover;
                }
            }
        }
    }
</style>
